export const departmentData = [
  { id: 1, name: "Production", code: "CS01", status: "ACTIVE" },
  { id: 2, name: "Planning", code: "ME01", status: "INACTIVE" },
  { id: 3, name: "Production & Planning", code: "CE01", status: "ACTIVE" },
  { id: 4, name: "IE", code: "EE01", status: "ACTIVE" },
  { id: 5, name: "IE & PI", code: "EC01", status: "INACTIVE" },
  { id: 6, name: "Operation", code: "IT01", status: "ACTIVE" },
  { id: 7, name: "Business", code: "CH01", status: "ACTIVE" },
  { id: 8, name: "Maintenance", code: "MN01", status: "ACTIVE" }, // added
  { id: 9, name: "Quality", code: "QL01", status: "ACTIVE" }, // added
  { id: 10, name: "Dept 1", code: "BT01", status: "INACTIVE" },
  { id: 11, name: "Dept 2", code: "AE01", status: "ACTIVE" },
  { id: 12, name: "Dept 3", code: "AU01", status: "INACTIVE" },
  { id: 13, name: "Dept 4", code: "PR01", status: "ACTIVE" },
];

export const stationData = [
  {
    stationId: 1,
    stationName: "Station 1",
    stationCode: "ST-01",
    department: "Production",
    status: "ACTIVE",
    createdDate: "01-01-2026",
  },
  {
    stationId: 2,
    stationName: "Station 2",
    stationCode: "ST-02",
    department: "Production",
    status: "ACTIVE",
    createdDate: "02-01-2026",
  },
  {
    stationId: 3,
    stationName: "Station 3",
    stationCode: "ST-03",
    department: "Planning",
    status: "ACTIVE",
    createdDate: "03-01-2026",
  },
  {
    stationId: 4,
    stationName: "Station 4",
    stationCode: "ST-04",
    department: "Planning",
    status: "INACTIVE",
    createdDate: "04-01-2026",
  },
  {
    stationId: 5,
    stationName: "Station 5",
    stationCode: "ST-05",
    department: "Business",
    status: "ACTIVE",
    createdDate: "05-01-2026",
  },
  {
    stationId: 6,
    stationName: "Station 6",
    stationCode: "ST-06",
    department: "Operation",
    status: "ACTIVE",
    createdDate: "06-01-2026",
  },
  {
    stationId: 7,
    stationName: "Station 7",
    stationCode: "ST-07",
    department: "IT",
    status: "ACTIVE",
    createdDate: "07-01-2026",
  },
  {
    stationId: 8,
    stationName: "Station 8",
    stationCode: "ST-08",
    department: "IT",
    status: "INACTIVE",
    createdDate: "08-01-2026",
  },
  {
    stationId: 9,
    stationName: "Station 9",
    stationCode: "ST-09",
    department: "Administration",
    status: "ACTIVE",
    createdDate: "09-01-2026",
  },
  {
    stationId: 10,
    stationName: "Station 10",
    stationCode: "ST-10",
    department: "Finance",
    status: "ACTIVE",
    createdDate: "10-01-2026",
  },
];

export const machineData = [
  {
    machineId: 1,
    machineName: "HP LaserJet Pro",
    machineCode: "MCH-001",
    stationName: "HR Workstation 01",
    department: "Human Resource",
    machineType: "Printer",
    status: "ACTIVE",
  },
  {
    machineId: 2,
    machineName: "Dell Optiplex 7090",
    machineCode: "MCH-002",
    stationName: "Admin Counter 01",
    department: "Administration",
    machineType: "Computer",
    status: "ACTIVE",
  },
  {
    machineId: 3,
    machineName: "Canon Scanner X200",
    machineCode: "MCH-003",
    stationName: "Accounts Desk A",
    department: "Accounts",
    machineType: "Scanner",
    status: "ACTIVE",
  },
  {
    machineId: 4,
    machineName: "ZKTeco Biometric",
    machineCode: "MCH-004",
    stationName: "Reception Counter",
    department: "Front Office",
    machineType: "Biometric",
    status: "ACTIVE",
  },
  {
    machineId: 5,
    machineName: "Lenovo ThinkCentre",
    machineCode: "MCH-005",
    stationName: "Clerk Workstation 01",
    department: "Clerk Section",
    machineType: "Computer",
    status: "ACTIVE",
  },
  {
    machineId: 6,
    machineName: "Epson EcoTank L3250",
    machineCode: "MCH-006",
    stationName: "Accounts Desk B",
    department: "Accounts",
    machineType: "Printer",
    status: "INACTIVE",
  },
  {
    machineId: 7,
    machineName: "HP ProDesk 600",
    machineCode: "MCH-007",
    stationName: "HR Workstation 02",
    department: "Human Resource",
    machineType: "Computer",
    status: "ACTIVE",
  },
  {
    machineId: 8,
    machineName: "Brother DCP Scanner",
    machineCode: "MCH-008",
    stationName: "Document Verification Desk",
    department: "Administration",
    machineType: "Scanner",
    status: "ACTIVE",
  },
  {
    machineId: 9,
    machineName: "Dell PowerEdge Server",
    machineCode: "MCH-009",
    stationName: "IT Support Desk 01",
    department: "IT",
    machineType: "Server",
    status: "ACTIVE",
  },
  {
    machineId: 10,
    machineName: "Acer Veriton Desktop",
    machineCode: "MCH-010",
    stationName: "Data Entry Desk 01",
    department: "IT",
    machineType: "Computer",
    status: "ACTIVE",
  },
  {
    machineId: 11,
    machineName: "Canon MF3010",
    machineCode: "MCH-011",
    stationName: "Finance Approval Desk",
    department: "Finance",
    machineType: "Printer",
    status: "ACTIVE",
  },
  {
    machineId: 12,
    machineName: "SecuGen Biometric",
    machineCode: "MCH-012",
    stationName: "Security Monitoring Desk",
    department: "Security",
    machineType: "Biometric",
    status: "ACTIVE",
  },
  {
    machineId: 13,
    machineName: "Lenovo ThinkServer",
    machineCode: "MCH-013",
    stationName: "IT Support Desk 02",
    department: "IT",
    machineType: "Server",
    status: "INACTIVE",
  },
  {
    machineId: 14,
    machineName: "HP ScanJet Pro",
    machineCode: "MCH-014",
    stationName: "Audit Review Station",
    department: "Accounts",
    machineType: "Scanner",
    status: "ACTIVE",
  },
  {
    machineId: 15,
    machineName: "Asus ExpertCenter",
    machineCode: "MCH-015",
    stationName: "Legal Review Cabin",
    department: "Legal",
    machineType: "Computer",
    status: "ACTIVE",
  },
];

export const MACHINE_TYPES = [
  { label: "PRINTER", value: "Printer" },
  { label: "SCANNER", value: "Scanner" },
  { label: "BIOMETRIC", value: "Biometric" },
  { label: "COMPUTER", value: "Computer" },
  { label: "SERVER", value: "Server" },
];

export const userData = [
  {
    id: 1,
    Name: "Rahul Sharma",
    email: "rahul.sharma@company.com",
    role: "Admin",
    department: "Business",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-01",
    updatedAt: "2026-02-10",
  },
  {
    id: 2,
    Name: "Neha Patil",
    email: "neha.patil@company.com",
    role: "Supervisor",
    department: "Production",
    status: "INACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-02",
    updatedAt: "2026-02-11",
  },
  {
    id: 3,
    Name: "Amit Verma",
    email: "amit.verma@company.com",
    role: "Technician",
    department: "Operation",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-03",
    updatedAt: "2026-02-12",
  },
  {
    id: 4,
    Name: "Priya Deshmukh",
    email: "priya.deshmukh@company.com",
    role: "Admin",
    department: "Dept 1",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-04",
    updatedAt: "2026-02-13",
  },
  {
    id: 5,
    Name: "Suresh Kulkarni",
    email: "suresh.kulkarni@company.com",
    role: "Planning-Manager",
    department: "Production & Planning",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-05",
    updatedAt: "2026-02-14",
  },
  {
    id: 6,
    Name: "Anjali Mehta",
    email: "anjali.mehta@company.com",
    role: "Analyst",
    department: "Planning",
    status: "INACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-06",
    updatedAt: "2026-02-15",
  },
  {
    id: 7,
    Name: "Rohit Joshi",
    email: "rohit.joshi@company.com",
    role: "Technician",
    department: "IE_Engineer",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-07",
    updatedAt: "2026-02-16",
  },
  {
    id: 8,
    Name: "Sneha Iyer",
    email: "sneha.iyer@company.com",
    role: "Supervisor",
    department: "Dept 2",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-08",
    updatedAt: "2026-02-17",
  },
  {
    id: 9,
    Name: "Kunal Shah",
    email: "kunal.shah@company.com",
    role: "Planning-Engineer",
    department: "IE & PI",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-09",
    updatedAt: "2026-02-18",
  },
  {
    id: 10,
    Name: "Pooja Nair",
    email: "pooja.nair@company.com",
    role: "Manager",
    department: "Operation",
    status: "INACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-10",
    updatedAt: "2026-02-19",
  },
  {
    id: 11,
    Name: "Vikas Yadav",
    email: "vikas.yadav@company.com",
    role: "Admin",
    department: "Business",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-11",
    updatedAt: "2026-02-20",
  },
  {
    id: 12,
    Name: "Ritu Malhotra",
    email: "ritu.malhotra@company.com",
    role: "Plant-Head",
    department: "Dept 3",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-12",
    updatedAt: "2026-02-21",
  },
  {
    id: 13,
    Name: "Deepak Singh",
    email: "deepak.singh@company.com",
    role: "Supervisor",
    department: "Production",
    status: "INACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-13",
    updatedAt: "2026-02-22",
  },
  {
    id: 14,
    Name: "Manish Gupta",
    email: "manish.gupta@company.com",
    role: "Technician",
    department: "Admin",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-14",
    updatedAt: "2026-02-23",
  },
  {
    id: 15,
    Name: "Kavita Rao",
    email: "kavita.rao@company.com",
    role: "Admin",
    department: "Planning",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-15",
    updatedAt: "2026-02-24",
  },
  {
    id: 16,
    Name: "Arjun Kapoor",
    email: "arjun.kapoor@company.com",
    role: "Planning-Engineer",
    department: "Production & Planning",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-16",
    updatedAt: "2026-02-25",
  },
  {
    id: 17,
    Name: "Nikita Chavan",
    email: "nikita.chavan@company.com",
    role: "Admin",
    department: "Dept 4",
    status: "INACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-17",
    updatedAt: "2026-02-26",
  },
  {
    id: 18,
    Name: "Sanjay Pawar",
    email: "sanjay.pawar@company.com",
    role: "Planning-Manager",
    department: "Production",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-18",
    updatedAt: "2026-02-27",
  },
  {
    id: 19,
    Name: "Meera Kulkarni",
    email: "meera.kulkarni@company.com",
    role: "Admin",
    department: "Dept 1",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-19",
    updatedAt: "2026-02-28",
  },
  {
    id: 20,
    Name: "Akash Mishra",
    email: "akash.mishra@company.com",
    role: "Technician",
    department: "IE & PI",
    status: "INACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-20",
    updatedAt: "2026-03-01",
  },
  {
    id: 21,
    Name: "Sonali Bhosale",
    email: "sonali.bhosale@company.com",
    role: "Supervisor",
    department: "Dept 2",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-21",
    updatedAt: "2026-03-02",
  },
  {
    id: 22,
    Name: "Nitin Jadhav",
    email: "nitin.jadhav@company.com",
    role: "Planning-Engineer",
    department: "IE",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-22",
    updatedAt: "2026-03-03",
  },
  {
    id: 23,
    Name: "Shweta More",
    email: "shweta.more@company.com",
    role: "Admin",
    department: "Planning",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-23",
    updatedAt: "2026-03-04",
  },
  {
    id: 24,
    Name: "Rakesh Thakur",
    email: "rakesh.thakur@company.com",
    role: "Manager",
    department: "Operation",
    status: "INACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-24",
    updatedAt: "2026-03-05",
  },
  {
    id: 25,
    Name: "Pallavi Joshi",
    email: "pallavi.joshi@company.com",
    role: "Admin",
    department: "Business",
    status: "ACTIVE",
    createdBy: "Admin",
    createdAt: "2026-02-25",
    updatedAt: "2026-03-06",
  },
];

export const shiftData = [
  {
    id: 1,
    name: "Morning Shift",
    code: "SH01",
    startTime: "08:00 AM",
    endTime: "04:00 PM",
    totalHours: "8",
    status: "ACTIVE",
    createdAt: "2026-02-01",
  },
  {
    id: 2,
    name: "Evening Shift",
    code: "SH02",
    startTime: "02:00 PM",
    endTime: "10:00 PM",
    totalHours: "8",
    status: "INACTIVE",
    createdAt: "2026-02-02",
  },
  {
    id: 3,
    name: "Night Shift",
    code: "SH03",
    startTime: "10:00 PM",
    endTime: "06:00 AM",
    totalHours: "8",
    status: "ACTIVE",
    createdAt: "2026-02-03",
  },
  {
    id: 4,
    name: "General Shift",
    code: "SH04",
    startTime: "09:00 AM",
    endTime: "06:00 PM",
    totalHours: "9",
    status: "ACTIVE",
    createdAt: "2026-02-04",
  },
  {
    id: 5,
    name: "Flexible Shift",
    code: "SH05",
    startTime: "10:00 AM",
    endTime: "07:00 PM",
    totalHours: "9",
    status: "INACTIVE",
    createdAt: "2026-02-05",
  },
  {
    id: 6,
    name: "Weekend Shift",
    code: "SH06",
    startTime: "09:00 AM",
    endTime: "05:00 PM",
    totalHours: "8",
    status: "ACTIVE",
    createdAt: "2026-02-06",
  },
  {
    id: 7,
    name: "Split Shift",
    code: "SH07",
    startTime: "08:00 AM",
    endTime: "12:00 PM",
    totalHours: "4",
    status: "INACTIVE",
    createdAt: "2026-02-07",
  },
  {
    id: 8,
    name: "Rotational Shift",
    code: "SH08",
    startTime: "07:00 AM",
    endTime: "03:00 PM",
    totalHours: "8",
    status: "ACTIVE",
    createdAt: "2026-02-08",
  },
  {
    id: 9,
    name: "Graveyard Shift",
    code: "SH09",
    startTime: "11:00 PM",
    endTime: "07:00 AM",
    totalHours: "8",
    status: "INACTIVE",
    createdAt: "2026-02-09",
  },
  {
    id: 10,
    name: "On Call Shift",
    code: "SH10",
    startTime: "06:00 PM",
    endTime: "12:00 AM",
    totalHours: "6",
    status: "ACTIVE",
    createdAt: "2026-02-10",
  },
  {
    id: 11,
    name: "Training Shift",
    code: "SH11",
    startTime: "10:00 AM",
    endTime: "04:00 PM",
    totalHours: "6",
    status: "ACTIVE",
    createdAt: "2026-02-11",
  },
  {
    id: 12,
    name: "Support Shift",
    code: "SH12",
    startTime: "01:00 PM",
    endTime: "09:00 PM",
    totalHours: "8",
    status: "INACTIVE",
    createdAt: "2026-02-12",
  },
  {
    id: 13,
    name: "Maintenance Shift",
    code: "SH13",
    startTime: "07:00 AM",
    endTime: "03:00 PM",
    totalHours: "8",
    status: "ACTIVE",
    createdAt: "2026-02-13",
  },
  {
    id: 14,
    name: "Late Night Shift",
    code: "SH14",
    startTime: "09:00 PM",
    endTime: "05:00 AM",
    totalHours: "8",
    status: "INACTIVE",
    createdAt: "2026-02-14",
  },
  {
    id: 15,
    name: "Early Bird Shift",
    code: "SH15",
    startTime: "05:00 AM",
    endTime: "01:00 PM",
    totalHours: "8",
    status: "ACTIVE",
    createdAt: "2026-02-15",
  },
];

export const SHIFT = [
  { value: "1", label: "1st" },
  { value: "2", label: "2nd" },
  { value: "3", label: "3rd" },
];

export const STATUS_LHB_DATA = [
  { value: "Pending", label: "PENDING" },
  { value: "Approved", label: "APPROVED" },
  { value: "Rejected", label: "REJECTED" },
];

export const employeeReportData = [
  {
    srNo: 1,
    employeeNumber: "EMP001",
    employeeName: "Amit Sharma",
    department: "Production",
    role: "Technician",
    date: "2026-03-01",
    shift: "1st",
    projectNumber: "PRJ001",
    projectName: "Raychem Plant Setup",
    stationName: "Station 1",
    subActivity: "Assembly",
    microActivity: "Bolt Tightening",
    totalHours: "06:30",
  },
  {
    srNo: 2,
    employeeNumber: "EMP002",
    employeeName: "Rahul Verma",
    department: "Maintenance",
    role: "Technician",
    date: "2026-03-01",
    shift: "2nd",
    projectNumber: "PRJ002",
    projectName: "Machine Repair",
    stationName: "Station 3",
    subActivity: "Inspection",
    microActivity: "Quality Check",
    totalHours: "05:00",
  },
  {
    srNo: 3,
    employeeNumber: "EMP003",
    employeeName: "Priya Patel",
    department: "Quality",
    role: "Inspector",
    date: "2026-03-02",
    shift: "1st",
    projectNumber: "PRJ003",
    projectName: "Cable Assembly",
    stationName: "Station 2",
    subActivity: "Testing",
    microActivity: "Voltage Test",
    totalHours: "07:00",
  },
  {
    srNo: 4,
    employeeNumber: "EMP004",
    employeeName: "Rohit Singh",
    department: "Production",
    role: "Operator",
    date: "2026-03-02",
    shift: "3rd",
    projectNumber: "PRJ004",
    projectName: "Transformer Setup",
    stationName: "Station 4",
    subActivity: "Wiring",
    microActivity: "Panel Wiring",
    totalHours: "06:45",
  },
  {
    srNo: 5,
    employeeNumber: "EMP005",
    employeeName: "Sneha Shah",
    department: "Maintenance",
    role: "Engineer",
    date: "2026-03-03",
    shift: "1st",
    projectNumber: "PRJ005",
    projectName: "Machine Calibration",
    stationName: "Station 1",
    subActivity: "Calibration",
    microActivity: "Sensor Setup",
    totalHours: "06:10",
  },
  {
    srNo: 6,
    employeeNumber: "EMP006",
    employeeName: "Vikas Kumar",
    department: "Production",
    role: "Technician",
    date: "2026-03-03",
    shift: "2nd",
    projectNumber: "PRJ006",
    projectName: "Panel Installation",
    stationName: "Station 5",
    subActivity: "Installation",
    microActivity: "Mounting",
    totalHours: "07:20",
  },
  {
    srNo: 7,
    employeeNumber: "EMP007",
    employeeName: "Karan Mehta",
    department: "Quality",
    role: "Inspector",
    date: "2026-03-04",
    shift: "1st",
    projectNumber: "PRJ007",
    projectName: "Circuit Testing",
    stationName: "Station 2",
    subActivity: "Testing",
    microActivity: "Signal Test",
    totalHours: "05:50",
  },
  {
    srNo: 8,
    employeeNumber: "EMP008",
    employeeName: "Anjali Desai",
    department: "Production",
    role: "Technician",
    date: "2026-03-04",
    shift: "3rd",
    projectNumber: "PRJ008",
    projectName: "Heat Shrink Process",
    stationName: "Station 3",
    subActivity: "Heating",
    microActivity: "Tube Shrinking",
    totalHours: "06:00",
  },
  {
    srNo: 9,
    employeeNumber: "EMP009",
    employeeName: "Deepak Yadav",
    department: "Maintenance",
    role: "Technician",
    date: "2026-03-05",
    shift: "2nd",
    projectNumber: "PRJ009",
    projectName: "Motor Repair",
    stationName: "Station 4",
    subActivity: "Repair",
    microActivity: "Bearing Replacement",
    totalHours: "05:30",
  },
  {
    srNo: 10,
    employeeNumber: "EMP010",
    employeeName: "Neha Kapoor",
    department: "Production",
    role: "Operator",
    date: "2026-03-05",
    shift: "1st",
    projectNumber: "PRJ010",
    projectName: "Cable Routing",
    stationName: "Station 1",
    subActivity: "Routing",
    microActivity: "Cable Placement",
    totalHours: "06:40",
  },
];

export const employeeAttendanceData = [
  {
    srNo: 1,
    employeeNumber: "EMP001",
    employeeName: "Rahul Sharma",
    department: "Production",
    date: "2026-03-12",
    shift: "1st",
    totalHoursBooked: "8",
    attendanceStatus: "Present",
  },
  {
    srNo: 2,
    employeeNumber: "EMP002",
    employeeName: "Priya Patel",
    department: "Maintenance",
    date: "2026-03-12",
    shift: "1st",
    totalHoursBooked: "4",
    attendanceStatus: "Present",
  },
  {
    srNo: 3,
    employeeNumber: "EMP003",
    employeeName: "Amit Singh",
    department: "Quality",
    date: "2026-03-12",
    shift: "1st",
    totalHoursBooked: "0",
    attendanceStatus: "Absent",
  },
  {
    srNo: 4,
    employeeNumber: "EMP004",
    employeeName: "Rohit Mehta",
    department: "Production",
    date: "2026-03-12",
    shift: "2nd",
    totalHoursBooked: "7",
    attendanceStatus: "Present",
  },
  {
    srNo: 5,
    employeeNumber: "EMP005",
    employeeName: "Sneha Shah",
    department: "Maintenance",
    date: "2026-03-12",
    shift: "2nd",
    totalHoursBooked: "3",
    attendanceStatus: "Absent",
  },
  {
    srNo: 6,
    employeeNumber: "EMP006",
    employeeName: "Vikas Kumar",
    department: "Production",
    date: "2026-03-12",
    shift: "3rd",
    totalHoursBooked: "8",
    attendanceStatus: "Present",
  },
  {
    srNo: 7,
    employeeNumber: "EMP007",
    employeeName: "Karan Mehta",
    department: "Quality",
    date: "2026-03-12",
    shift: "1st",
    totalHoursBooked: "6",
    attendanceStatus: "Present",
  },
  {
    srNo: 8,
    employeeNumber: "EMP008",
    employeeName: "Anjali Desai",
    department: "Production",
    date: "2026-03-12",
    shift: "3rd",
    totalHoursBooked: "2",
    attendanceStatus: "Absent",
  },
  {
    srNo: 9,
    employeeNumber: "EMP009",
    employeeName: "Deepak Yadav",
    department: "Maintenance",
    date: "2026-03-12",
    shift: "2nd",
    totalHoursBooked: "8",
    attendanceStatus: "Present",
  },
  {
    srNo: 10,
    employeeNumber: "EMP010",
    employeeName: "Neha Kapoor",
    department: "Production",
    date: "2026-03-12",
    shift: "1st",
    totalHoursBooked: "0",
    attendanceStatus: "Absent",
  },
];
export const machineUtilizationData = [
  {
    srNo: 1,
    machineId: "MC001",
    machineName: "Hydraulic Press",
    machineCode: "HP-01",
    stationName: "Station 3",
    department: "Production",
    projectNumber: "PRJ-001",
    projectName: "Raychem Plant Setup",
    subActivity: "Sub Activity 1A",
    microActivity: "Micro Activity 1A-1",
    totalHoursUsed: "6",
    date: "2026-03-10",
  },
  {
    srNo: 2,
    machineId: "MC002",
    machineName: "CNC Machine",
    machineCode: "CNC-02",
    stationName: "Station 2",
    department: "Production",
    projectNumber: "PRJ-002",
    projectName: "Cable Assembly",
    subActivity: "Sub Activity 2A",
    microActivity: "Micro Activity 2A-1",
    totalHoursUsed: "7",
    date: "2026-03-10",
  },
  {
    srNo: 3,
    machineId: "MC003",
    machineName: "Drill Machine",
    machineCode: "DR-03",
    stationName: "Station 1",
    department: "Maintenance",
    projectNumber: "PRJ-003",
    projectName: "Machine Repair",
    subActivity: "Sub Activity 3A",
    microActivity: "Micro Activity 3A-1",
    totalHoursUsed: "4",
    date: "2026-03-10",
  },
  {
    srNo: 4,
    machineId: "MC004",
    machineName: "Lathe Machine",
    machineCode: "LT-04",
    stationName: "Station 4",
    department: "Production",
    projectNumber: "PRJ-004",
    projectName: "Transformer Setup",
    subActivity: "Sub Activity 1B",
    microActivity: "Micro Activity 1B-2",
    totalHoursUsed: "5",
    date: "2026-03-10",
  },
  {
    srNo: 5,
    machineId: "MC005",
    machineName: "Welding Machine",
    machineCode: "WL-05",
    stationName: "Station 5",
    department: "Production",
    projectNumber: "PRJ-005",
    projectName: "Frame Assembly",
    subActivity: "Sub Activity 2B",
    microActivity: "Micro Activity 2B-2",
    totalHoursUsed: "6",
    date: "2026-03-10",
  },
  {
    srNo: 6,
    machineId: "MC006",
    machineName: "Grinding Machine",
    machineCode: "GR-06",
    stationName: "Station 2",
    department: "Maintenance",
    projectNumber: "PRJ-006",
    projectName: "Tool Calibration",
    subActivity: "Sub Activity 3B",
    microActivity: "Micro Activity 3B-2",
    totalHoursUsed: "3",
    date: "2026-03-10",
  },
  {
    srNo: 7,
    machineId: "MC007",
    machineName: "Heat Furnace",
    machineCode: "HF-07",
    stationName: "Station 3",
    department: "Production",
    projectNumber: "PRJ-007",
    projectName: "Heat Shrink Process",
    subActivity: "Sub Activity 1C",
    microActivity: "Micro Activity 1C-3",
    totalHoursUsed: "7",
    date: "2026-03-10",
  },
  {
    srNo: 8,
    machineId: "MC008",
    machineName: "Laser Cutter",
    machineCode: "LC-08",
    stationName: "Station 4",
    department: "Production",
    projectNumber: "PRJ-008",
    projectName: "Panel Fabrication",
    subActivity: "Sub Activity 2C",
    microActivity: "Micro Activity 2C-3",
    totalHoursUsed: "6",
    date: "2026-03-10",
  },
  {
    srNo: 9,
    machineId: "MC009",
    machineName: "Compressor",
    machineCode: "CP-09",
    stationName: "Station 1",
    department: "Maintenance",
    projectNumber: "PRJ-009",
    projectName: "Air System Setup",
    subActivity: "Sub Activity 3C",
    microActivity: "Micro Activity 3C-3",
    totalHoursUsed: "5",
    date: "2026-03-10",
  },
  {
    srNo: 10,
    machineId: "MC010",
    machineName: "Press Brake",
    machineCode: "PB-10",
    stationName: "Station 5",
    department: "Production",
    projectNumber: "PRJ-010",
    projectName: "Metal Bending",
    subActivity: "Sub Activity 1D",
    microActivity: "Micro Activity 1D-4",
    totalHoursUsed: "6",
    date: "2026-03-10",
  },
];

export const departmentWorkloadData = [
  {
    srNo: 1,
    departmentName: "Production",
    departmentCode: "CS01",
    totalEmployees: 25,
    totalProjects: 4,
    activitiesCompleted: 120,
    totalHoursWorked: 950,
    avgHoursPerEmployee: 38,
    date: "2026-03-01",
  },
  {
    srNo: 2,
    departmentName: "Maintenance",
    departmentCode: "MN01",
    totalEmployees: 15,
    totalProjects: 2,
    activitiesCompleted: 60,
    totalHoursWorked: 420,
    avgHoursPerEmployee: 28,
    date: "2026-03-01",
  },
  {
    srNo: 3,
    departmentName: "Quality",
    departmentCode: "QL01",
    totalEmployees: 12,
    totalProjects: 3,
    activitiesCompleted: 75,
    totalHoursWorked: 350,
    avgHoursPerEmployee: 29,
    date: "2026-03-01",
  },
  {
    srNo: 4,
    departmentName: "Operation",
    departmentCode: "IT01",
    totalEmployees: 10,
    totalProjects: 2,
    activitiesCompleted: 50,
    totalHoursWorked: 280,
    avgHoursPerEmployee: 28,
    date: "2026-03-01",
  },
  {
    srNo: 5,
    departmentName: "Planning",
    departmentCode: "ME01",
    totalEmployees: 8,
    totalProjects: 3,
    activitiesCompleted: 40,
    totalHoursWorked: 210,
    avgHoursPerEmployee: 26,
    date: "2026-03-01",
  },
  {
    srNo: 6,
    departmentName: "IE",
    departmentCode: "EE01",
    totalEmployees: 7,
    totalProjects: 2,
    activitiesCompleted: 35,
    totalHoursWorked: 190,
    avgHoursPerEmployee: 27,
    date: "2026-03-01",
  },
  {
    srNo: 7,
    departmentName: "Production & Planning",
    departmentCode: "CE01",
    totalEmployees: 18,
    totalProjects: 3,
    activitiesCompleted: 90,
    totalHoursWorked: 510,
    avgHoursPerEmployee: 28,
    date: "2026-03-01",
  },
  {
    srNo: 8,
    departmentName: "IE & PI",
    departmentCode: "EC01",
    totalEmployees: 9,
    totalProjects: 2,
    activitiesCompleted: 45,
    totalHoursWorked: 260,
    avgHoursPerEmployee: 29,
    date: "2026-03-01",
  },
  {
    srNo: 9,
    departmentName: "Business",
    departmentCode: "CH01",
    totalEmployees: 6,
    totalProjects: 1,
    activitiesCompleted: 30,
    totalHoursWorked: 140,
    avgHoursPerEmployee: 23,
    date: "2026-03-01",
  },
  {
    srNo: 10,
    departmentName: "Dept 1",
    departmentCode: "BT01",
    totalEmployees: 5,
    totalProjects: 1,
    activitiesCompleted: 20,
    totalHoursWorked: 120,
    avgHoursPerEmployee: 24,
    date: "2026-03-01",
  },
];

export const customerProjectWorkloadData = [
  {
    srNo: 1,
    customerName: "Reliance Industries",
    customerCode: "CUST001",
    projectNumber: "PRJ-001",
    projectName: "Raychem Plant Setup",
    productName: "Heat Shrink Tubing",
    unitNumber: "UNIT-01",
    department: "Production",
    stationName: "Station 3",
    totalActivities: 25,
    totalHoursWorked: 180,
    techniciansInvolved: 8,
    date: "2026-03-10",
  },
  {
    srNo: 2,
    customerName: "Tata Power",
    customerCode: "CUST002",
    projectNumber: "PRJ-002",
    projectName: "Cable Assembly",
    productName: "Power Cable",
    unitNumber: "UNIT-02",
    department: "Production",
    stationName: "Station 2",
    totalActivities: 20,
    totalHoursWorked: 150,
    techniciansInvolved: 6,
    date: "2026-03-10",
  },
  {
    srNo: 3,
    customerName: "Adani Energy",
    customerCode: "CUST003",
    projectNumber: "PRJ-003",
    projectName: "Transformer Build",
    productName: "Transformer Coil",
    unitNumber: "UNIT-03",
    department: "Production",
    stationName: "Station 4",
    totalActivities: 18,
    totalHoursWorked: 130,
    techniciansInvolved: 5,
    date: "2026-03-10",
  },
  {
    srNo: 4,
    customerName: "L&T",
    customerCode: "CUST004",
    projectNumber: "PRJ-004",
    projectName: "Panel Installation",
    productName: "Electrical Panel",
    unitNumber: "UNIT-04",
    department: "Production & Planning",
    stationName: "Station 5",
    totalActivities: 22,
    totalHoursWorked: 165,
    techniciansInvolved: 7,
    date: "2026-03-10",
  },
  {
    srNo: 5,
    customerName: "Siemens",
    customerCode: "CUST005",
    projectNumber: "PRJ-005",
    projectName: "Automation Setup",
    productName: "Control Panel",
    unitNumber: "UNIT-05",
    department: "Production",
    stationName: "Station 1",
    totalActivities: 19,
    totalHoursWorked: 140,
    techniciansInvolved: 6,
    date: "2026-03-10",
  },
  {
    srNo: 6,
    customerName: "ABB",
    customerCode: "CUST006",
    projectNumber: "PRJ-006",
    projectName: "Circuit Testing",
    productName: "Switch Gear",
    unitNumber: "UNIT-06",
    department: "Quality",
    stationName: "Station 2",
    totalActivities: 17,
    totalHoursWorked: 120,
    techniciansInvolved: 5,
    date: "2026-03-10",
  },
  {
    srNo: 7,
    customerName: "Schneider Electric",
    customerCode: "CUST007",
    projectNumber: "PRJ-007",
    projectName: "Energy Meter Setup",
    productName: "Smart Meter",
    unitNumber: "UNIT-07",
    department: "Production",
    stationName: "Station 3",
    totalActivities: 21,
    totalHoursWorked: 155,
    techniciansInvolved: 6,
    date: "2026-03-10",
  },
  {
    srNo: 8,
    customerName: "GE Power",
    customerCode: "CUST008",
    projectNumber: "PRJ-008",
    projectName: "Turbine Panel",
    productName: "Control Board",
    unitNumber: "UNIT-08",
    department: "Production & Planning",
    stationName: "Station 4",
    totalActivities: 23,
    totalHoursWorked: 175,
    techniciansInvolved: 7,
    date: "2026-03-10",
  },
  {
    srNo: 9,
    customerName: "Hitachi Energy",
    customerCode: "CUST009",
    projectNumber: "PRJ-009",
    projectName: "Motor Control",
    productName: "Motor Panel",
    unitNumber: "UNIT-09",
    department: "Production",
    stationName: "Station 2",
    totalActivities: 16,
    totalHoursWorked: 115,
    techniciansInvolved: 5,
    date: "2026-03-10",
  },
  {
    srNo: 10,
    customerName: "BHEL",
    customerCode: "CUST010",
    projectNumber: "PRJ-010",
    projectName: "Generator Setup",
    productName: "Generator Unit",
    unitNumber: "UNIT-10",
    department: "Production",
    stationName: "Station 5",
    totalActivities: 24,
    totalHoursWorked: 185,
    techniciansInvolved: 8,
    date: "2026-03-10",
  },
];

export const DESIGNATION = [
  { label: "Operator", value: "OPERATOR" },
  { label: "Helper", value: "HELPER" },
  { label: "Painter", value: "PAINTER" },
  { label: "Welder", value: "WELDER" },
  { label: "Oil Filteration Operator", value: "OIL_FILTERATION_OPERATOR" },
  { label: "Kit Handler", value: "KIT_HANDLER" },
  { label: "Wireman", value: "WIREMAN" },
];